const keyCodes = {
    TAB: 'Tab',
    ENTER: 'Enter',
    SPACE: ' ',
    SPACE_IE11: 'Spacebar',
    ESCAPE: 'Escape',
    ESCAPE_IE11: 'Esc',
    ARROW_DOWN: 'ArrowDown',
    ARROW_DOWN_IE11: 'Down',
    ARROW_UP: 'ArrowUp',
    ARROW_UP_IE11: 'Up',
    HOME: 'Home',
    PAGE_UP: 'PageUp',
    PAGE_DOWN: 'PageDown',
    END: 'End'
};

export default keyCodes;
